<template>
  <div class="info-box">
    <section class="left-box">
      <div class="location-box">
        <i class="iconfont icon-ditu1"></i>
        <div style="cursor: pointer">
          <span>{{ searchForm.addressName }}</span>
        </div>
      </div>
      <div class="sort" >
        <BrowseSortBox></BrowseSortBox>
      </div>
    </section>

    <section class="right-box">
      <div class="chose-bar">
        <div
          :class="['type-box', { 'active-type': transType == ind }]"
          v-for="(item, ind) in typeList"
          :key="item"
          @click="transType = ind"
        >
          <i :class="['iconfont', iconList[ind], { font26: ind == 2 }]"></i>
          <span>{{ item }}</span>
        </div>
        <div :class="['input-box', {'focus-input':focusInput}]">
          <i class="el-icon-search"></i>
          <input type="text" v-model="searchForm.keyword" @focus="focusInput=true" @blur="focusInput=false" placeholder="Enter your restaurant name" />
        </div>
      </div>
      <div>
      </div>
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <el-skeleton-item variant="rect" class="tag-bar" />
        </template>
        <TagBar v-model="tagList"></TagBar>
      </el-skeleton>
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <el-skeleton-item variant="rect" class="cuise-bar" />
        </template>
        <template>
          <div class="cuise-bar">
            <swiper :options="swiperOption" ref="mySwiper" id="cuise-swiper">
              <swiper-slide class="cuise-item" v-for="(item,ind) in foodTypeList" :key="item.cuisineId">
                <div class="img">
                  <img :src="item.featuredImage" alt="cuiseImg">
                </div>
                <div class="name" :style="{ backgroundColor: colorList[ind%5]}">{{ item.cuisineName }}</div>
              </swiper-slide>
              <!-- 可选的控件 -->

              <!--前进后退按钮-->
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
          
        </template>
      </el-skeleton>
      <el-skeleton :loading="loading" animated>
          <template slot="template">
            <el-skeleton-item variant="rect" class="merchant-box" />
          </template>
          <template>
            <div class="merchant-box">
              <BrowseMerchantBox :offmerchantList="offmerchantList" :merchantList="merchantList"></BrowseMerchantBox>   
            </div>
          </template>
        </el-skeleton>
    </section>

    <!-- 回到顶部按钮 -->
    <el-backtop :bottom='128' :right='60'>
      <i class="el-icon-caret-top"></i>
    </el-backtop>
  </div>
</template>

<script>
import BrowseSortBox from '@/components/BrowseComps/BrowseSortBox.vue';
import TagBar from '@/components/BrowseComps/TagBar.vue';
import BrowseMerchantBox from '@/components/BrowseComps/BrowseMerchantBox.vue';
import { postGateway } from '@/request/index.js'
export default {
  name: "Browse",
  components: {
    BrowseSortBox,
    TagBar,
    BrowseMerchantBox
  },
  data() {
    return {
      focusInput: false,
      transType: 0,
      typeList: ["Delivety", "Pick-up", "Dine-in"],
      iconList: ["icon-waimai", "icon-01_zitidian", "icon-tangshi"],
      tagList: ['Free Delivery', '5 Stars'],
      foodTypeList: [],
      colorList: ['#FF0000', '#FF5C00', '#00588A', '#0030AA', '#005125'],
      loading: true,
      searchForm: {
        addressName: '',
        keyword: 'pizza', 
        sort: '', 
        tastRating: '', 
        serviceRating: '', 
        discount: '',
        lng: '',
        lat: ''
      },
      pages: {
        pageNum: 1,
        pageSize: 12
      },
      total: 0,
      merchantList: [],
      offmerchantList: [],
      swiperOption: {
        //幻灯片放映方向
        direction: "horizontal", //通常不与左右按钮一同使用
        slidesPerView: 10,
        spaceBetween: 15,
        //分页器配置项
        pagination: {
            el: ".swiper-pagination", //分页器的类名
            clickable: true, // 点击分页器跳切换到相应的幻灯片
            bottom: 0,
        },
        //前进后退按钮
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        //幻灯片播放配置项
        loop: false, //是否循环播放
        speed: 1000, // 发生页面切换动画时，动画的切换速度
        autoPlay: false,
        breakpoints: {
            1024: {
                slidesPerView: 7,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 8,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
        },
        on: {
            slideChangeTransitionEnd: function () {
                // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
            },
        },
      },
    };
  },
  created() {
    this.searchForm.addressName = this.$route.query.searchLoc
    this.getFoodTypeList();
    this.getOffmerchant();
    this.getNearMerchant(true);
  },
  mounted() {
    this.spideWindowScroll();
  },
  methods: {
    // 监听页面滚动
    spideWindowScroll() {
      const that = this
      window.onscroll = function () {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        if (scrollTop + windowHeight >= scrollHeight-1000) {
          that.loadMore = true
          if (that.pages.pageSize*that.pages.pageNum < that.total) {
              console.log('加载更多')
              that.pages.pageNum ++
              that.getNearMerchant()
          }
          // 数据全部加载完成
        }
      }
    },
    // 有优惠的商家
    getOffmerchant() {
      postGateway({
          url: '/customerWeb/index/queryMerchantOffByPage',
          method: 'GET',
          data: {
            pageNum: 1,
            pageSize: 20
          }
      }).then((res) => {
          if(res.code == 200){
            this.offmerchantList = res.data.filter(x=>x.merchantOff)
          }
      })
    },
    // 获取菜色分类列表
    getFoodTypeList() {
      postGateway({
        url: '/customerWeb/index/popularCategory',
        method: 'GET',
        data: {}
      }).then(res=>{
        this.foodTypeList = res.data
        this.loading = false;
      })
      .catch(()=>{
        this.loading = false;
      })
    },
    getNearMerchant(refresh=false){
      const { keyword, sort, tastRating, serviceRating, discount, lat,  lng} = this.searchForm
      postGateway({
        url: 'customerWeb/index/queryMerchantByPage',
        method: 'GET',
        data: {
          keyword, sort, tastRating, serviceRating, discount,
          pageNum: this.pages.pageNum,
          pageSize: this.pages.pageSize,
          cuisineId: this.nowCuiseId || "",
          type: this.transType,
          selfLontitude: lng,
          selfLatitude: lat,
        }
      }).then((res) => {
          if(refresh) {
            this.merchantList = [];
          }
          if(res.code == 200){
            this.merchantList = this.merchantList.concat(res.data.list)
            this.total = res.data.total
          }
      }).catch(err => {
        this.$message.error(err)
      })
    },
  }
};
</script>

<style scoped lang="scss">
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.info-box {
  display: flex;
  width: 100vw;
  padding: 0 4%;
  position: relative;
  padding-top: 10px;

  .left-box {
    padding: 20px 20px 0 0;
    position: sticky;
    top: 96px;
    width: 18%;
    min-height: 900px;
    min-width: 350px;
    height: calc(100vh - 96px);
    display: flex;
    flex-direction: column;

    .location-box {
      min-height: 48px;
      border-radius: 4px;
      background-color: #eeeeee;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 15px 0 15px;
      font-size: 18px;
      font-weight: 600;
      color: #000;
      font-family: Poppins, sans-serif;
      cursor: pointer;

      .icon-ditu1 {
        font-size: 28px;
        margin-right: 10px;
        color: $greenColor;
      }
    }
    .sort {
      margin-top: 24px;
      flex: 1;
    }
  }

  .right-box {
    width: 82%;
    display: flex;
    min-width: 550px;
    flex-direction: column;

    .chose-bar {
      padding-top: 20px;
      display: flex;

      .type-box {
        display: inline-flex;
        height: 48px;
        width: 135px;
        margin-right: 15px;
        background-color: #e9eaea;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        transition: all ease-in-out .2s;
        &:hover {
            background: #bfc5c5;
        }

        i {
          color: #000000;
          margin-right: 8px;
          font-size: 26px;
        }
        .font26 {
          font-size: 18px;
        }
      }

      .active-type {
        background: $greenColor;
        color: #fff;
        &:hover {
            background: #1daa63;
        }
        i {
          color: #fff;
        }
      }

      .input-box {
        flex: 1;
        border-radius: 4px;
        overflow: hidden;
        background-color: fff;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
        transition: all ease-in .2s;

        .el-icon-search {
          font-size: 26px;
          font-weight: 700;
          color: #9A47EE;
        }

        input {
          height: 100%;
          width: 100%;
          background-color: #fff;
          font-family: "Roboto", Sans-serif;
          font-size: 18px;
          font-weight: 400;
          flex: 1;
          color: #000;
          fill: #000;
          padding-left: 20px;
        }
      }
      .focus-input {
        box-shadow: rgba(0, 0, 0, 0.295) 0px 6px 12px, rgba(0, 0, 0, 0.316) 0px 3px 6px;
      }
    }
    .tag-bar {
      height: 40px;
      margin-top: 20px;
    }
    :deep(.cuise-bar) {
      min-height: 108px;
      width: 100%;
      margin: 20px 0 10px 0;
      display: flex;
      flex-wrap: nowrap;

      #cuise-swiper {
        padding: 2px;
        margin: 0;
        width: 100%;
      }

      .cuise-item {
        display: inline-flex;
        margin-right: 20px;
        flex-direction: column;
        height: 108px;
        width: 108px;
        max-width: 108px;
        min-width: 108px;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0px 0px 5px #BBBBBB;
        overflow: hidden;
        cursor: pointer;

        &:nth-child(1) {
          margin-left: 2px;
        }
        .img {
          flex: 1;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            height: 70px;
            width: 73px;
          }
        }
        .name {
          text-align: center;
          color: #fff;
          font-weight: 600;
          height: 30px;
          display: flex;
          font-size: 14px;
          justify-content: center;
          align-items: center;
          width: 100%;
          background: #FF0000;
        }
      }

    }

  }
  :deep(.merchant-box) {
      flex: 1;
      min-height: 800px;
      margin-top: 10px;
    }
}
</style>
<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@1,500&display=swap");
</style>
